/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import type {GxSession} from 'interfaces';
import {Modal, Button} from 'react-bootstrap';
import SyntaxHighlighter from 'react-syntax-highlighter';
import {docco} from 'react-syntax-highlighter/dist/esm/styles/hljs';

type TProps = {
	modelGxSession: GxSession | unknown;
	show: boolean;
	setShow: (param: boolean) => void;
	title: string;
};

const ModalGxRxSessionViewJson = ({
	modelGxSession = {},
	show,
	setShow,
	title,
}: TProps) => {
	const handleClose = () => setShow(false);

	return (
		<div className="p-col-12 margin">
			<Modal
				size="xl"
				show={show}
				onHide={handleClose}
				className="custom-modal-style">
				<Modal.Header closeButton>
					<Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
				</Modal.Header>
				<Modal.Body className="show-grid">
					<SyntaxHighlighter language="json" style={docco}>
						{JSON.stringify(modelGxSession, undefined, 4)}
					</SyntaxHighlighter>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
};

export default ModalGxRxSessionViewJson;
